import * as P from 'fp-ts/Predicate';
import * as RR from 'fp-ts/ReadonlyRecord';
export * from 'fp-ts-std/ReadonlyRecord';
export * from 'fp-ts/ReadonlyRecord';
export var isNonEmpty = P.not(RR.isEmpty);
